import { render, staticRenderFns } from "./JobStatusChangeRequestsPage.vue?vue&type=template&id=ef261e52&"
import script from "./JobStatusChangeRequestsPage.vue?vue&type=script&lang=js&"
export * from "./JobStatusChangeRequestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports